module.exports = __webpack_public_path__ + "media/images/gallery/constellations/aquila/aql_vis-6a34cace28d77114649de5b05b237eee.jpg";